import type {
  AddressResolution,
  AddressSuggestion,
} from "@/components/ui/address-autocomplete";

/**
 * What a chosen address suggestion changes on an enterprise profile: the street
 * line, the city and the postal code, in one patch so an autosaving editor saves
 * once. Never the MRC, région or province — the server resolves those from the
 * saved address and refuses them from a submission.
 *
 * An address the server could not confirm keeps the suggestion's own text and
 * leaves the city and postal code as they were; the save reports any problem.
 */
export function enterpriseAddressPatch(
  result: AddressResolution,
  suggestion: AddressSuggestion,
): { address: string; city?: string; zip_code?: string } {
  if (!result.confirmed) return { address: suggestion.text };
  return {
    address: result.address || suggestion.text,
    ...(result.city ? { city: result.city } : {}),
    ...(result.zip_code ? { zip_code: result.zip_code } : {}),
  };
}
